import * as actions from './actions';
import { mutations, state } from './mutations';

export default {
  actions,
  mutations,
  state,
};